import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import qs from 'query-string';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Reflux from 'reflux';
import get from 'lodash/get';
import classnames from 'classnames';
import i18n from 'i18n';

import {languageChange} from 'redux/modules/app';
import {registrationRequest} from 'redux/modules/shared';

import {PartnerMessageDialog} from 'apps/influencers/shared/controllers';
import AppActions from 'modules/legacy/js/actions/app';
import AuthActions from 'modules/legacy/js/actions/auth';
import recaptcha from 'modules/legacy/js/mixins/recaptcha';
import {LoginSupportLinks as SupportLinks} from 'modules/shared/containers';
import {PartnerFormRoute} from 'apps/advertisers/PartnerForm';

import RoleForms from './containers/RoleForm/RoleForm';

import { loginCoverImg, logoImgObs } from 'assets/images';
import { getDefaultTitle } from 'config/app';

import styles from './Registration.less';

function mapStateToProps({app, shared}) {
  const {session, user} = shared;
  const {currentLanguage, partnerSettings} = app;
  return {
    session,
    user,
    currentLanguage,
    partnerSettings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    registrationRequest,
    languageChange
  }, dispatch);
}

const Registration = createClass({
  propTypes: {
    partnerSettings: PropTypes.object,
    user: PropTypes.object,
    session: PropTypes.object,
    location: PropTypes.object,
    registrationRequest: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired
  },

  defaultProps: {
    user: {},
    session: {},
    location: {},
    partnerSettings: null
  },

  mixins: [
    recaptcha,
    Reflux.listenTo(AuthActions.registerError, 'onRegisterError'),
    Reflux.listenTo(AppActions.reCAPTCHALoaded, 'updateReCaptchaWidget')
  ],

  componentWillMount() {
    const query = qs.parse(this.props.location.search);
    const {role} = query;
    this.setState({role});
  },

  componentWillReceiveProps({session, user}) {
    if (session.error) return this.onRegisterError(session.error);
    if (user) {
      return AuthActions.registerSuccess({
        user,
        token: session.token,
        account: user.account
      });
    }
    return null;
  },

  onRegisterError(error) {
    this.showError(error);
    this.updateReCaptchaWidget();
  },

  onSendRegistrationData(form) {
    const {currentLanguage: locale} = this.props;
    const {role} = this.state;
    const {email, password} = form;
    const params = {
      email, password, role, locale
    };

    if (role === 'advertiser') {
      const {name, lastName} = form;
      Object.assign(params, {name, lastName});
    }

    return this.props.registrationRequest(params);
  },

  showError({message}) {
    AppActions.displayAlert({
      type: 'error',
      message
    });
  },

  render() {
    const {partnerSettings, location} = this.props;
    const {role} = this.state;
    const query = qs.parse(location.search);
    const partnerId = get(query, 'partnerId');
    const curtainStyle = !role ? {backgroundImage: `url('${loginCoverImg}')`} : {};
    if (partnerSettings) return <PartnerFormRoute />;

    const curtainClass = classnames(
      'col-md-7', styles.curtain,
      {
        'empty-cover': !role,
        [styles.influencer]: role === 'influencer',
        [styles.advertiser]: role === 'advertiser'
      }
    );

    const flip = {transform: `rotateY(${role === 'influencer' ? '0deg' : '180deg'})`};
    const companyName = getDefaultTitle()

    return (
      <div className='vf-row no-space'>
        <div className='col-md-5 col-xs-12'>
          <div className='flex no-space start-md center-xs'>
            <div className='register width100'>
              <div className='background' />
              <div className='overlay' />

              <div className='form width100'>
                <div className='flex between-xs margin-vertical-1x'>
                  <img alt='' src={logoImgObs} className='logo' />

                  <Link
                    href='/login'
                    to='/login'
                    className='vf-btn vf-btn-primary outline vf-btn--sm login-btn-link'
                    style={{borderRadius: '2px', padding: '1rem 3rem'}}
                  >
                    {i18n.get('REGISTER_LOG_IN')}
                  </Link>
                </div>

                <RoleForms
                  role={role}
                  query={query}
                  onChangeRole={r => this.setState({role: r})}
                  onSubmit={this.onSendRegistrationData}
                />
              </div>

              <SupportLinks />

              {partnerId && role === 'influencer' && (
                <PartnerMessageDialog partnerId={partnerId} />
              )}
            </div>
          </div>
        </div>
        <div className={curtainClass} style={curtainStyle}>
          {role ?
            <div className='flex flex-wrap flex-justify-space-around width100'>
              <div className={styles['flip-container']}>
                <div className={styles.flipper} style={flip}>
                  <Card icon='icon-ic-colaborate' info={i18n.get('REGISTER_INFLUENCER_DESCRIPTION_1')} front />
                  <Card icon='icon-ic-search' info={i18n.get('REGISTER_ADVERTISER_DESCRIPTION_1')} />
                </div>
              </div>

              <div className={styles['flip-container']}>
                <div className={styles.flipper} style={flip}>
                  <Card icon='icon-ic-post' info={i18n.get('REGISTER_INFLUENCER_DESCRIPTION_2')} front />
                  <Card icon='icon-ic-safe' info={i18n.get('REGISTER_ADVERTISER_DESCRIPTION_2',{companyName})} />
                </div>
              </div>

              <div className={styles['flip-container']}>
                <div className={styles.flipper} style={flip}>
                  <Card icon='icon-ic-warranty' info={i18n.get('REGISTER_INFLUENCER_DESCRIPTION_3',{companyName})} front />
                  <Card icon='icon-ic-money' info={i18n.get('REGISTER_ADVERTISER_DESCRIPTION_3',{companyName})} />
                </div>
              </div>
            </div>
            :
            <div className='curtain' />
          }
        </div>
      </div>
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Registration);

const Card = ({icon, info, front}) => (
  <div className={classnames(styles.card, {[styles.front]: front, [styles.back]: !front})}>
    <i className={`vf-icon ${icon}`} />
    <p>{info}</p>
  </div>
);

Card.propTypes = {
  icon: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  front: PropTypes.bool
};

Card.defaultProps = {
  front: false
};
